// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1441":"13c982ef35dc513b","4491":"981125f67ee3dcd4"}[chunkId] + ".js";
};